export default {
  title: 'Aktualizuj profil {{name}}',
  form: {
    name: {
      label: 'Nazwa',
      placeholder: 'Wprowadź pełne imię właściciela',
    },
    email: {
      label: 'E-mail',
      placeholder: 'Wprowadź osobisty e-mail właściciela',
      tooltip: 'Osobisty e-mail właściciela/menedżera restauracji. Używany jako login do dashboardu',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
